export default function DriveSyncInfo({ invoice }) {
  const hasContent = invoice.driveWebViewLink || invoice.sourceReceipts?.length > 0 || invoice.sourceFolderPath;
  if (!hasContent) return null;

  return (
    <div style={{ padding: '0 32px 20px' }} className="no-print">
      {invoice.sourceFolderPath && (
        <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 6 }}>
          📂 Source folder: <strong>{invoice.sourceFolderPath}</strong>
        </div>
      )}
      {invoice.driveWebViewLink && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', background: 'var(--blue-bg)', borderRadius: 8, fontSize: 12.5, marginBottom: 8 }}>
          <span>📁</span>
          <span style={{ color: 'var(--blue)' }}>Saved to Google Drive:</span>
          <a href={invoice.driveWebViewLink} target="_blank" rel="noreferrer" style={{ color: 'var(--blue)', fontWeight: 600 }}>
            Open XLSX in Drive ↗
          </a>
        </div>
      )}
      {invoice.sourceReceipts?.length > 0 && (
        <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 4 }}>
          Sources: {invoice.sourceReceipts.map(r => r.driveName || r.driveFileId).filter(Boolean).join(', ')}
        </div>
      )}
    </div>
  );
}
